import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function OffIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M20 17.9738L20.02 18.0038C20.34 18.3238 20.34 18.8438 20.02 19.1638C19.7 19.4838 19.17 19.4838 18.85 19.1638L17.71 18.0238C17.63 18.1038 17.55 18.1838 17.46 18.2538C15.97 19.5938 14.02 20.3338 12 20.3338C9.81 20.3338 7.71 19.4638 6.17 17.9138C4.62 16.3638 3.75 14.2738 3.75 12.0838C3.75 10.7738 4.06 9.49376 4.65 8.35376L5.25 7.42376C5.56 7.01376 6 6.90376 6.33 7.12376C6.66 7.34376 6.73 7.84376 6.47 8.23376L6.26 8.55376C5.61 9.60377 5.25 10.8138 5.25 12.0738C5.25 13.8638 5.96 15.5838 7.23 16.8438C8.49 18.1138 10.21 18.8238 12 18.8238C13.62 18.8238 15.18 18.2438 16.4 17.1838C16.49 17.1138 16.57 17.0338 16.65 16.9538L16.6 16.9038L15.31 15.6238L12.76 13.0738V15.0638C12.76 15.5438 12.42 15.9338 12.01 15.9338C11.6 15.9338 11.26 15.5438 11.26 15.0638V11.5638L5.36 5.65376C5.04 5.33376 5.04 4.81376 5.36 4.49376C5.68 4.17376 6.2 4.16376 6.53 4.49376L12.03 9.99376L13.53 11.5038L17.68 15.6538C18.36 14.5838 18.74 13.3238 18.74 12.0638C18.74 10.8038 18.37 9.59377 17.73 8.53376L17.52 8.22376C17.26 7.83376 17.33 7.33376 17.66 7.11376C17.99 6.89376 18.48 7.02376 18.74 7.41376C18.74 7.41376 19.16 8.00377 19.46 8.57376C20.01 9.63377 20.24 10.8438 20.24 12.0638C20.24 13.7438 19.7 15.3538 18.75 16.7238L20 17.9738Z"
        fill="white"
      />
      <path
        d="M12.74 5.12375V8.48375L11.25 7.01375H11.24V5.12375C11.24 4.64375 11.58 4.25375 11.99 4.25375C12.4 4.25375 12.74 4.64375 12.74 5.12375Z"
        fill="white"
      />
    </SvgIcon>
  );
}
